import Modal from "@common/Modal"

export default function DocumentErrorModal(props: any) {
    let { handleClose, show } = props

    return (
        <div className="model-outer upload-error-popup">
            <Modal show={show} handleClose={() => { handleClose() }}>
                <div className="modal-header">
                    <div className="addon-img">
                        <img src="/images/danger.png" alt=""/>
                    </div>
                </div>
                <div className='modal-body'>
                    <h2>Some error found in uploaded image. Make sure document/photo should be correct</h2>
                    <span><i className="ic-clearclose red"></i>Image uploaded</span>
                    <span><i className="ic-clearclose red"></i>Image size should be between 25kb to 5mb</span>
                </div>
            </Modal>
        </div>
    )
}